<template>
    <div class="w-full inline-flex flex-col justify-center select-none px-4 mb-12">

        <div class="mt-6 px-8">

            <h2 class="text-gray-800 dark:text-white text-lg mb-3">
                Format des horaires :
            </h2>
            <div class="flex items-center justify-center">

                <div
                    class="inline-flex items-center rounded-full text-gray-800 bg-gray-200 text-sm p-1 justify-between w-full h-10 dark:bg-[#27282a]">
                    <div class="p-2 rounded-full cursor-pointer w-1/2 text-center noSelect umami--click--button-format dark:text-white"
                        v-for="format in formats" :key="format.slug"
                        :class='{ "bg-white dark:bg-[#202024]": selectedFormat === format.slug }' role='button'
                        :aria-pressed="selectedFormat === format.slug ? 'true' : 'false'" @click="selectFromat(format)">
                        {{ format.label }}
                    </div>
                </div>
            </div>
        </div>

        <Plus class="mt-12" />

        <!-- Next -->
        <div class="mt-6">
            <h1 class="text-gray-800 dark:text-white text-lg mb-3 flex items-center">
                <span class="underline">Prochaines fonctionnalités</span> <span
                    class="ml-1 uppercase bg-yellow-500 p-1 font-bold text-xs rounded-lg text-white">PLUS</span>
            </h1>
            <p class="mt-3 text-sm font-medium text-gray-700 dark:text-white">
            <ul class="list-disc pl-4 mt-1">
                <li><s>🌓 Mode sombre</s></li>
                <li><s>🚌 Nouveau réseau T2C <span class="text-xs italic text-gray-800 dark:text-gray-200">(en cours)</span>
                    </s></li>
                <li>📍 Itinéraires <span class="text-xs italic text-gray-800 dark:text-gray-200">(en bêta)</span> </li>
                <li>🎟️ Achat et validation de tickets</li>
                <li>😎 Compte premium</li>
                <li>🍎 Application iOs</li>
            </ul>
            </p>
        </div>

        <!-- FAQ -->
        <div class="mt-12">
            <h1 class="text-gray-800 dark:text-white text-lg mb-3">
                🤔 <span class="underline">Qui est dérrière cette application ?</span>
            </h1>
            <p class="mt-3 text-sm font-medium text-gray-700 dark:text-white">
                <span class="text-base">🍾 T2c.app c'est <b>+30 000 utilisateurs</b> et plus de <b>5 000 000 d'horaires
                        consultés</b> !</span>
                <br>
                <br>
                Nous sommes une petite équipe <b>indépendante et <u>bénévole</u></b> voulant donner un <b>coup de neuf</b>
                aux applications de transports en commun présentes sur Clermont-Ferrand.
                <br>
                <br>
                🎂 La première version de t2c.app a vu le jour en septembre <b>2019</b>.
                <br>
                Depuis, nous ne cessons d'améliorer <b>l'interface</b>, les <b>fonctionnalités</b> ainsi que la
                <b>fiabilité</b> des horaires.
            </p>
        </div>

        <!-- Rating -->
        <div class="mt-12">
            <h1 class="text-gray-800 dark:text-white text-2xl mb-3">
                🎉 Votre avis est utile !
            </h1>
            <div class="flex items-center justify-center">
                <div v-for='i in [1, 2, 3, 4, 5]' :key='i'>
                    <svg v-if='i === 6' class="w-8 h-8 text-gray-300 dark:text-gray-500" fill="currentColor"
                        viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
                        </path>
                    </svg>

                    <svg v-else class="w-8 h-8 text-yellow-400" fill="currentColor" viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
                        </path>
                    </svg>
                </div>
                <p class="ml-2 text-sm font-medium text-gray-700 dark:text-gray-200">4.9 sur 5</p>
            </div>
            <p class="mt-3 text-sm font-medium text-gray-700 dark:text-white">Pensez à voter sur le
                <a class="text-blue-700 dark:text-blue-400 underline"
                    href="https://play.google.com/store/apps/details?id=org.t2c.app&hl=fr" target="_blank">Playstore</a> et
                laissez un commentaire pour nous permettre de continuer à amerliorer l'application 😄
            </p>

            <p class="mt-3 text-sm font-medium text-gray-700 dark:text-white">
                La meilleure façon de nous aider à grandir est de <b>faire connaitre l'application</b>, ça peut être dans
                votre cercle proche, vos amis, vos collègues...
                <br>
            <div class="flex flex-col items-center justify-center mt-2">
                Il est aussi possible de faire des dons :
                <a href="https://www.paypal.com/paypalme/camtosh/10" target="_blank">
                    <button type="button"
                        class="paypal bg-yellow-600 bg-opactiy-70 font-medium rounded-lg text-sm px-5 py-2 text-center inline-flex items-center mr-2 mt-2 text-white dark:text-slate-800">
                        <svg class="w-4 h-4 mr-2 -ml-1 text-blue-800 bg-opacity-80" aria-hidden="true" focusable="false"
                            data-prefix="fab" data-icon="paypal" role="img" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512">
                            <path fill="currentColor"
                                d="M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4 .7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9 .7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z">
                            </path>
                        </svg>
                        Faire un don avec PayPal
                    </button>
                </a>
            </div>
            </p>
        </div>
    </div>
</template>
<style type="text/css">
.paypal {
    background: #ffd573;
}
</style>
<script type="text/javascript">
import Plus from "@/components/Plus.vue";

export default {
    name: "Settings",
    components: {
        Plus,
    },
    data() {
        return {
            formats: [
                { label: '5 min', slug: 'simple' },
                { label: '16:20', slug: 'full' },
            ],
            selectedFormat: 'full'
        }
    },
    mounted() {
        this.selectedFormat = this.$store.state.selectedTimeFormat;
    },
    methods: {
        selectFromat(format) {
            this.selectedFormat = format.slug;
            this.$store.commit("selectTimeFormat", format.slug);
        }
    }
};
</script>
